export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const FETCH_APPOINTMENT_STATUS = 'FETCH_APPOINTMENT_STATUS';

export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';

export const DRAWER_TOGGLE = 'DRAWER_TOGGLE';
export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';
export const SET_IP_BLOCKED = 'SET_IP_BLOCKED';
export const OPEN_VERSION_UPDATE_MODAL = 'OPEN_VERSION_UPDATE_MODAL';
export const CLOSE_VERSION_UPDATE_MODAL = 'CLOSE_VERSION_UPDATE_MODAL';
export const SKIPPED_VERSION = 'SKIPPED_VERSION';
